import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function paymentMethodReducer(
  state = initialState.paymentMethod,
  action
) {
  switch (action.type) {
    case types.LOAD_PAYMENT_METHOD_SUCCESS:
      return action.paymentMethod;
    case types.SAVE_PAYMENT_METHOD_OPTIMISTIC:
      return state.map((paymentMethod) =>
        paymentMethod.recurringPaymentCardID ===
        action.paymentMethod.recurringPaymentCardID
          ? action.paymentMethod
          : paymentMethod
      );
    case types.DELETE_PAYMENT_METHOD_OPTIMISTIC:
      return state.filter(
        (paymentMethod) =>
          paymentMethod.recurringPaymentCardID !==
          action.paymentMethod.recurringPaymentCardID
      );
    case types.DELETE_PAYMENT_METHOD_LAST_OPTIMISTIC:
      return action.paymentMethod;
    case types.CREATE_PAYMENT_METHOD_SUCCESS:
      return state === undefined ||
        state[0].CurrentState === "None" ||
        state[0].CurrentState === "Undefined"
        ? [action.paymentMethod]
        : [...state, { ...action.paymentMethod }];
    default:
      return state;
  }
}
